import {toast} from 'react-toastify';
import { log } from '../../Helper';
async function updateLoadBuild(url, requestOptions) {
    const notify_success = () => {
      toast.success("Load details updated successfully");
    };
  
     await fetch(url, requestOptions).then(async (response) => {
      log("updateLoadBuild",response);
      if (response["status"] === 200) {
        notify_success();
      } else if (response["status"] === 409) {
        toast.warn("Machine is already loaded.");
      } else if (response["status"] === 206) {
        notify_success();
        toast.warn("File upload failed");
      } else {
        toast.error("Load details update failed");
      }
      let value = await response.json();
      return value;
    });
  }
  export default updateLoadBuild;